"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIsTopAreaNavigationVisible = void 0;
var _featureToggles = require("@ori/feature-toggles");
var _constants = require("../constants");
const useIsTopAreaNavigationVisible = () => {
  const {
    isFeatureEnabled
  } = (0, _featureToggles.useFeatureToggles)();
  return isFeatureEnabled(_constants.TopAreaFeature.UseTopAreaNavigationMenu);
};
exports.useIsTopAreaNavigationVisible = useIsTopAreaNavigationVisible;